<template>
  <div class="more">
    <div class="more__wrapper">
      <div class="more__trigger">
        <SvgIcon :name="icon" :key="_uid" />
      </div>
      <div class="more__menu">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { SvgIcon } from '@/components/ui'

export default {
  name: 'PopoverMenu',
  components: { SvgIcon },
  props: {
    icon: {
      type: String,
      default: 'chat-more-dots',
    },
  },
}
</script>

<style lang="scss" scoped>
.more {
  z-index: 2;
  &__wrapper {
    position: relative;
    z-index: 3;
  }
  &__trigger {
    position: relative;
    z-index: 1;
    font-size: 0;
    color: $dark;
    cursor: pointer;
    transition: color 0.25s $ease;
    &:hover {
      color: $primary;
    }
    .svg-icon {
      font-size: 16px;
    }
  }
  &__menu {
    position: absolute;
    right: 0;
    top: 100%;
    width: 130px;
    z-index: 3;
    background: #ffffff;
    box-shadow: 0px 7px 27px 10px rgba(180, 187, 198, 0.15);
    border-radius: 10px;
    padding: 16px 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.1s $ease;
    a {
      display: inline-flex;
      align-items: center;
      width: 100%;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 4px;
      padding: 5px;
      color: $dark;
      text-decoration: none;
      transition: color 0.25s $ease;
      ::v-deep .svg-icon {
        margin-left: auto;
        &--chat-more-dots-horizontal {
          font-size: 3px;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
      &:hover {
        color: $primary;
        svg {
          circle {
            stroke: $primary;
          }
          path {
            stroke: $primary;
          }
        }
      }
    }

    .chat-head-leave {
      &:hover {
        color: #C34343;
        opacity: 0.8;
        svg {
          circle {
            stroke: #C34343;
          }
          path {
            stroke: #C34343;
          }
        }
      }
    }
  }
  &:hover {
    .more__menu {
      opacity: 1;
      pointer-events: all;
    }
  }
}
</style>
